"use client";

import React, { createContext, useEffect } from "react";
import { Session } from "next-auth";
import mixpanel from "mixpanel-browser"; /// DO NOT INSTALL TYPES. lib will crash

export const MixpanelContext = createContext({});

export interface MixpanelProviderProps {
  children: React.ReactNode;
  session?: Session | null;
}

const MIXPANEL_TOKEN = "80ca1d3efc3aa7ae6384aa1087055036";

export const initMixpanel = () => {
  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: true,
  });
};

function MixpanelProvider(props: MixpanelProviderProps) {
  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      initMixpanel();
    }
  }, []);

  return props.children;
}

export default MixpanelProvider;
